module.exports = __webpack_public_path__ + "8e9d9d519aab00b50a1f567ac076c150.ttf";